<template>
  <div class="main-container">
    <!-- 商品 -->
    <div v-for="(type, index) in productDatas" :key="index">
      <img v-if="type.effectImg" src="https://p1.fishqc.net/FuRV2cQhUaY_s8r78jSLbZveUBKm" width="1006px" style="margin: 62px 0 19px">
      <div :class="type.bgClass" >
        <div v-for="category in type.categorys" :key="category.desc" class="category-container" :style="{marginBottom: category.mb}">
          <div class="desc">{{ category.desc }}</div>
          <div class="product-list">
            <div v-for="pro in category.products" :key="pro.src" class="product-container display_flex justify-content_flex-justify" :class="pro.isNoMb?'mb-0':''" @click="toProductDetail(pro.type, pro.id)">
              <div class="productImg" :style="{backgroundImage: `url(${pro.img})`, backgroundSize: pro.bgSize, backgroundPosition: pro.bgPosition}">
                <img v-for="(tag, index) in pro.tags" :key="index" :src="tag.src" :class="tag.class">
              </div>
              <div class="product-text-box display_flex justify-content_flex-justify flex-direction_column flex_1">
                <div class="name" v-html="pro.name"></div>
                <div>
                  <div class="address">品牌所在地：{{ pro.address }}</div>
                  <div class="tips-box">{{ pro.tips }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 功效图 -->
    <div v-for="item in bottomImgs" :key="item.src" :style="{marginTop: item.mt}">
      <img :src="item.src" alt="">
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
div {
  box-sizing: border-box;
}

.mb-0 {
  margin-bottom: 0!important;
}

.desc {
  width: 880px;
  margin-bottom: 20px;
  text-align: left;
  font-size: 24px;
  font-weight: 800;
  line-height: 36px;
}

.main-container {
  box-sizing: border-box;
  height: 11900px;
  padding-top: 1074px;
  margin: 100px auto 0;
  background: url('https://p1.fishqc.net/lqqJK1qpDxhGKNAFM3hH3g77UlFO') center center no-repeat;
  background-size: auto 100%;
  color: #1B5EAD;
}

.type-bg_1 {
  height: 2773px;
  padding: 246px 0 0;
  background: url('https://p1.fishqc.net/FghUBDAklPTkW4d2LVL8jizpGT1w') center center no-repeat;
  background-size: contain;
}

.type-bg_2 {
  height: 1513px;
  padding: 196px 0 0;
  background: url('https://p1.fishqc.net/FhnfcVd5c6t_GWNQUkqA3mhlHvj_') center center no-repeat;
  background-size: contain;
}

.category-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  // margin-bottom: 150px;
}

.product-list {
  display: flex;
  flex-wrap: wrap;
  width: 1012px;
  padding: 0 35px;
}

.product-container {
  width: 462px;
  height: 225px;
  padding: 12px 0 10px 12px;
  margin-bottom: 30px;
  background: #7BF3EB;
  border: 2px solid #55B0F3;
  border-radius: 8px;
  cursor: pointer;

  &:nth-child(odd) {
    margin-right: 18px
  }
}

.productImg {
  position: relative;
  width: 174px;
  // height: 197px;
  border-radius: 8px;
  background-color: #fff;
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;

  img {
    position: absolute;
    width: 80px;
    height: 80px;
    bottom: -10px;
  }
}

.green-icon{
  right: -8px;
}

.effect-icon_1 {
  right: -8px;
}

.effect-icon_2 {
  width: 70px!important;
  height: 70px!important;
  right: 44px;
}

.effect-icon_3 {
  width: 70px!important;
  height: 70px!important;
  right: -8px;
}

.product-text-box {
  margin-left: 16px;
  font-size: 18px;
  font-weight: bold;
  text-align: left;

  .name {
    font-size: 20px;
    line-height: 24px;
  }

  .tips-box {
    width: 99px;
    height: 30px;
    margin-top: 15px;
    color: #fff;
    background: #1B5EAD;
    border-radius: 16px;
    text-align: center;
    line-height: 30px;
  }
}

</style>
<script>
import { myMixin } from '@/mixin/mixin.js'
export default {
  // name: '2023-618',
  mixins: [myMixin],
  data() {
    return {
      productDatas: [
        {
          bgClass: 'type-bg_1',
          categorys: [
          {
            desc: '精华液含高浓度的功效成分，满足护肤需求。选择安全的精华液非常重要，强效护肤，更能保障肌肤健康。',
            mb: '161px',
            products: [
              {
                img: 'https://p1.fishqc.net/FonG5aeaEI_THjkWuh-H7IiaOmoQ',
                name: 'PURID朴理<br>创研修护焕漾精华液<br>(2号精华)',
                address: '中国',
                tips: '抗红御氧',
                type: 'cosmetic',
                id: 'uBKKOZ0Ao5UKRKyj9CEC6g',
                tags: [
                  { src: 'https://p1.fishqc.net/FsSAn-Hj02ROZMg-VwKL3MUXat5I', class: 'green-icon' }
                ]
              },
              {
                img: 'https://p1.fishqc.net/FrZcla2xqYCmKu4_FeF3RCghqQ-c',
                name: 'GRASUS 瑰倚丝<br>果萃柔肤精华液',
                address: '中国',
                tips: '软化角质',
                type: 'cosmetic',
                id: 'g9RkjEhY_8FoisLx5_PO4Q',
                tags: [
                  { src: 'https://p1.fishqc.net/FsSAn-Hj02ROZMg-VwKL3MUXat5I', class: 'green-icon' }
                ]
              },
              {
                img: 'https://p1.fishqc.net/FrNiKk-S1DclO_Prtx0Es4GC39V9',
                name: 'HELENA RUBINSTEIN<br>赫莲娜<br>至盈抚纹精华液',
                tips: '立体抚纹',
                address: '法国',
                type: 'cosmetic',
                id: '4gzuhzJvhN-mF8qNaKY5Gw',
                isNoMb: true,
                tags: [
                  { src: 'https://p1.fishqc.net/FsSAn-Hj02ROZMg-VwKL3MUXat5I', class: 'green-icon' }
                ]
              },
              {
                img: 'https://p1.fishqc.net/FpotQ0JicZLT9zPjjDAGTId13NhG',
                name: "KIEHL'S科颜氏<br>集焕白均衡亮肤淡斑精华液",
                tips: '净透亮泽',
                address: '美国',
                type: 'cosmetic',
                id: 'MD_L6OxxcHLVZXrQPsfTMQ',
                isNoMb: true,
                tags: [
                  { src: 'https://p1.fishqc.net/FsSAn-Hj02ROZMg-VwKL3MUXat5I', class: 'green-icon' }
                ]
              }
            ]
          },
          {
            desc: '眼周肌肤角质层薄、易受伤害，容易缺水。正确的眼部护理需要选择安全的产品，让眼周肌肤更加健康柔滑，使双眼明亮有神。',
            mb: '150px',
            products: [
              {
                img: 'https://p1.fishqc.net/Fte_SVS7K9FBpBdEei7j-Jm7ZnYV',
                name: 'GÈNECHER简莳<br>臻妍眼部精华液',
                address: '中国',
                tips: '淡纹提亮',
                tags: [
                  { src: 'https://p1.fishqc.net/FsSAn-Hj02ROZMg-VwKL3MUXat5I', class: 'green-icon' }
                ],
                type: 'cosmetic',
                id: 'icxXsubnNgpik7aFQonidQ',
                isNoMb: true,
                bgSize: 'cover',
              },
              {
                img: 'https://p1.fishqc.net/Fpts7g3iq9Qq9uOlYVQWUv89WY4t',
                name: 'URIAGE依泉<br>多功能眼霜',
                tips: '滋润眼部',
                address: '中国',
                type: 'cosmetic',
                id: 'KZSD3pOUpqe27_uzIVr5cA',
                isNoMb: true,
                tags: [
                  { src: 'https://p1.fishqc.net/FsSAn-Hj02ROZMg-VwKL3MUXat5I', class: 'green-icon' }
                ]
              }
            ]
          },
          {
            desc: '夏季肌肤易出现水油失衡的问题。选择安全合适的面霜，让肌肤清爽不油腻。选择绿鱼面霜，享受清爽体验。',
            mb: '150px',
            products: [
              {
                img: 'https://p1.fishqc.net/FjtuYF7PyNWSYYBN93JFjbA3bROc',
                name: 'MyClorisLand花皙蔻<br>菁纯牡丹抗皱淡纹精华霜',
                tips: '紧致淡纹',
                address: '中国',
                type: 'cosmetic',
                id: 'li4ioIgu8L4wYXMSzN4LYA',
                isNoMb: true,
                tags: [
                  { src: 'https://p1.fishqc.net/FsSAn-Hj02ROZMg-VwKL3MUXat5I', class: 'green-icon' }
                ],
                bgSize: '90%'
              },
              {
                img: 'https://p1.fishqc.net/FvH77xWmgA66Ln8wNkCMjeH396E1',
                name: 'SKINCEUTICALS修丽可<br>紧致塑颜面霜',
                tips: '卓效抗老',
                address: '美国',
                type: 'cosmetic',
                id: 'HcLChmVn61Jxp9fVCxFG2w',
                isNoMb: true,
                tags: [
                  { src: 'https://p1.fishqc.net/FsSAn-Hj02ROZMg-VwKL3MUXat5I', class: 'green-icon' }
                ],
                bgSize: '120%',
                bgPosition: '44% 0%'
              }
            ]
          },
          {
            desc: '儿童牙齿娇嫩，口腔黏膜敏感。选择专为儿童设计的牙膏更需要关注安全，才能有效地保护宝宝口腔健康。',
            mb: '140px',
            products: [
              {
                img: 'https://p1.fishqc.net/Fm_uPEHnyrJW_uu-TrKncCObYlOt',
                name: '舒客宝贝<br>长效防护儿童牙膏',
                tips: '12小时防护',
                address: '中国',
                type: 'cosmetic',
                id: 'mtoLRQHMq_FvdD4RwtoO_g',
                isNoMb: true,
                tags: [
                  { src: 'https://p1.fishqc.net/FsSAn-Hj02ROZMg-VwKL3MUXat5I', class: 'green-icon' }
                ]
              },
              {
                img: 'https://p1.fishqc.net/FoVpiOCqKZuozXk_CiYCxdUx63p-',
                name: 'SK SOAP 儿童牙膏<br>（提子味）',
                tips: '温和天然',
                address: '日本',
                type: 'cosmetic',
                id: 'G3Tyq-09mNRTbvyiqSSZDQ',
                isNoMb: true,
                tags: [
                  { src: 'https://p1.fishqc.net/FsSAn-Hj02ROZMg-VwKL3MUXat5I', class: 'green-icon' }
                ]
              }
            ]
          },
          {
            desc: '劣质儿童洗浴产品可能会造成对宝宝血肿、过敏、皮炎等过度刺激。选择安全绿鱼优品，是保护孩子健康成长的必要之举。',
            mb: '145px',
            products: [
              {
                img: 'https://p1.fishqc.net/FlisxG1o2vhKbrxDzFmtC2CBcIuF',
                name: 'Mambino Naturals<br>二合一舒敏洗发沐浴泡泡<br> (甜橙味)',
                address: '美国',
                tips: '温柔洁净',
                tags: [
                  { src: 'https://p1.fishqc.net/FsSAn-Hj02ROZMg-VwKL3MUXat5I', class: 'green-icon' }
                ],
                type: 'cosmetic',
                id: '9TVx9oKP1WPJDDcjYbhhAA',
                isNoMb: true,
                bgSize: '150%',
                bgPosition: '50% 320%'
              },
              {
                img: 'https://p1.fishqc.net/Fklf_a15nXvgTzbwjvxH1teCosl7',
                name: 'Childs Farm<br>英国宝宝农场<br>有机红桑子小童泡泡沐浴露',
                titleFont: true,
                address: '英国',
                tips: '细腻亲肤',
                tags: [
                  { src: 'https://p1.fishqc.net/FsSAn-Hj02ROZMg-VwKL3MUXat5I', class: 'green-icon' }
                ],
                type: 'cosmetic',
                id: 'fHg4kSGCA-tdU1wdIurb0A',
                isNoMb: true,
                bgSize: '150%',
                bgPosition: '42% 440%'
              }
            ]
          }
          ],
        },
        { 
          effectImg: 'https://p1.fishqc.net/FuRV2cQhUaY_s8r78jSLbZveUBKm',
          bgClass: 'type-bg_2',
          categorys: [
          {
            desc: '保健食品补充营养，调节身体机能，促进健康。各种科学测评功效显著的保健食品满足你的不同健康需求。',
            mb: '142px',
            products: [
              {
                img: 'https://p1.fishqc.net/Fpj6IQej8FhG0AICsTiWOq2muxEA',
                name: 'Doppelherz双心<br>高端护眼宝',
                tips: '双效润眼',
                address: '德国',
                type: 'food',
                id: 'nwP2iMHEcCWxDuo8IqCNow',
                isNoMb: true,
                tags: [
                  { src: 'https://p1.fishqc.net/FmF41xyiXcX2EqM3wfhYzs2teVzU', class: 'effect-icon_2' },
                  { src: 'https://p1.fishqc.net/Fh2fRUfXmeUElQcmPqJ_FCbqxbqL', class: 'effect-icon_3' }
                ]
              },
              {
                img: 'https://p1.fishqc.net/FsNKXdvHCSNypgBYzI-E6LoX3koR',
                name: "VIERRA惟爱论<br>美白片",
                tips: '亮白光泽',
                address: '澳洲',
                type: 'cosmetic',
                id: 'PBUfp_gTUElgaFdl2BpCNQ',
                tags: [
                  { src: 'https://p1.fishqc.net/FmXB0udt_p10MXkaFUk71tXKByUz', class: 'effect-icon_1' }
                ],
                isNoMb: true
              }
            ]
          },
          {
            desc: '夏日护肤，美白面膜必不可少。选用功效显著的面膜，补水保湿的同时更能快速提亮肤色，让你拥有水润透白的肌肤。',
            mb: '140px',
            products: [
              {
                img: 'https://p1.fishqc.net/Fm57oLppYDQMl_F7ht3MVy2knKin',
                name: 'DR.CI:LABO城野医生<br>光学深层净白水凝面膜',
                tips: '水润透白',
                address: '日本',
                type: 'cosmetic',
                id: 'PUo4KcpZUC_kOpzGTnMYgw',
                isNoMb: true,
                tags: [
                  { src: 'https://p1.fishqc.net/FpzQO1Gexfr9KMqkqPLfZmfLzh2V', class: 'effect-icon_1' }
                ]
              },
              {
                img: 'https://p1.fishqc.net/Fm9VnCuOcONFrk4oQlWW6ObuhnzU',
                name: 'INNISFREE悦诗风吟<br>济州石榴活妍焕采精华密集修护面膜套装',
                tips: '清爽服帖',
                address: '韩国',
                type: 'cosmetic',
                id: '68wrN4S4Ns0KZjIjDVV3_w',
                isNoMb: true,
                tags: [
                  { src: 'https://p1.fishqc.net/FpzQO1Gexfr9KMqkqPLfZmfLzh2V', class: 'effect-icon_1' }
                ]
              }
            ]
          },
          {
            desc: '夏日高温易引起皮肤炎症和水分流失，更需选具有保湿和舒缓功效显著的身体乳，才可滋润和保护肌肤。',
            mb: '0',
            products: [
              {
                img: 'https://p1.fishqc.net/FpWNyD6tz1V15da_lSaXJdV3JpVW',
                name: 'CeraVe<br>长效保湿修复乳',
                tips: '保湿抗炎',
                address: '法国',
                type: 'cosmetic',
                id: 'G8DSWGQVu9-PBfLpFkvDiA',
                isNoMb: true,
                tags: [
                  { src: 'https://p1.fishqc.net/FtIdYNDze733FYzrR83e3qLCk8fY', class: 'effect-icon_2' },
                  { src: 'https://p1.fishqc.net/FlQ59Rcc_Oa6UjW1GRfeAnYRYnIQ', class: 'effect-icon_3' }
                ],
                bgSize: 'cover',
              },
              {
                img: 'https://p1.fishqc.net/Fj4e9lHh0IIWyBAsWC4IXJPt_4JQ',
                name: 'NIVEA妮维雅<br>深层润肤乳液',
                tips: '性价比高',
                address: '德国',
                type: 'cosmetic',
                id: 'syRVqfvDqCizUwkg0irO1w',
                isNoMb: true,
                tags: [
                  { src: 'https://p1.fishqc.net/FtIdYNDze733FYzrR83e3qLCk8fY', class: 'effect-icon_2' },
                  { src: 'https://p1.fishqc.net/FlQ59Rcc_Oa6UjW1GRfeAnYRYnIQ', class: 'effect-icon_3' }
                ]
              }
            ]
          },
          ],
        }
      ],
      bottomImgs: [
        {
          src: 'https://p1.fishqc.net/FvCR8KMhCHehsaiTeJyAzrL7_XY6',
          mt: '46px'
        },
        {
          src: 'https://p1.fishqc.net/FpZXgjSOuwGbcAzO3EdZsYLt-lgK',
          mt: '34px'
        },
        {
          src: 'https://p1.fishqc.net/Flce83yuhw4Z6hD5zPBt2rSqyucw',
          mt: '44px'
        },
        {
          src: 'https://p1.fishqc.net/FkTr5opEZC4Mz29tZh7FDGjy6DEo',
          mt: '30px'
        },
        {
          // src: 'https://p1.fishqc.net/Fjfto80UbKh_pFTqlJZWOT8U-pnz',
          src: 'https://p1.fishqc.net/FtsqqrBpLiZ8bjOAqwFgRVPADQM7',
          mt: '88px'
        },
        {
          src: 'https://p1.fishqc.net/FqlDPaj6yPDys9apu4qtE9IaX8if',
          mt: '88px'
        },
        {
          src: 'https://p1.fishqc.net/FtOShTmZI2P6wPLLh-WtieMSjkDn',
          mt: '88px'
        },
        {
          src: 'https://p1.fishqc.net/FvZ5yItS3v9CbQMEg3tFTeTMSxHN',
          mt: '88px'
        },
        {
          src: 'https://p1.fishqc.net/FozCNnjpwBvXj2qCGLH72pLNLKc8',
          mt: '105px'
        },
      ]
    }

  },
  computed: {
    swiper() {
      return this.$refs.order_report_Swiper.$swiper
    }
  },
  mounted() {
    // var position  =  this.$route.query.position
    // this.scrollTo(position)
    this.currentlang = window.localStorage.getItem("LOCALE") || 'chs'
  },
  methods: {
    scrollTo(position) {
      var that = this;
      var scroll_H;
      this.$nextTick(function () {
        if (position == 'greenrank') {
          var d = document.getElementById("greenrank");
          var topPos = d.offsetTop;
          scroll_H = topPos - 110; //减去header高度
        } else {
          scroll_H = this.$refs[position].offsetTop - 110; //减去header高度
        }
        //全局方法
        that.scrollToY(scroll_H, 1500, 'easeInOutQuint');
      })
    },
    toProductDetail(type, prdid) {
      this.$router.push({
        path: '/product/' + type + '/' + prdid
      })

    }
  }
}
</script>